import React from "react";
import { useNavigate } from "react-router-dom";
import { Box } from "@mui/system";
import { useSelector } from "react-redux";
import GridTable from "../../components/table/gridTable";
import Loader from "../../components/SharedLayouts/Loader";

const TimelineTable = ({ setTimelineModal }) => {
  const { timelines } = useSelector((state) => state?.investment);

  const { pendingTimeline } = useSelector((state) => state?.investment);

  const navigate = useNavigate();

  const handleRowClick = (params, event) => {
    setTimelineModal({ type: "EDIT", timeline: params?.row });
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 300,
    },
    {
      field: "name",
      headerName: "Title",
      width: 400,
      renderCell: (params) => params.row?.title,
    },
  ];

  return (
    <div className="mt-10 mb-8">
      {pendingTimeline && timelines?.length < 1 ? (
        <Loader />
      ) : (
        <Box sx={{ overflowX: "auto", width: "100%", cursor: "pointer" }}>
          <GridTable
            rows={timelines}
            columns={columns}
            noSearch
            noReport
            type={"investment"}
            handleRowClick={(params, event) => handleRowClick(params, event)}
          />
        </Box>
      )}
    </div>
  );
};

export default TimelineTable;
